<div class="app-toast" role="status">
  <span class="app-toast-message">{{ message() }}</span>
  @if (actionLabel(); as label) {
    <button type="button" class="app-toast-action" data-testid="toast-action" (click)="onAction()">
      {{ label }}
    </button>
  }
  <button type="button" class="app-toast-close" data-testid="toast-close" (click)="close()" aria-label="Close">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
